import { Moon, Sun } from "lucide-react";

import { useTheme } from "@/components/theme-provider";
import { Button } from "@/components/ui/button";

const themeCycleOrder = ["light", "dark", "system"] as const;
type ThemeMode = (typeof themeCycleOrder)[number];

export function ModeToggle() {
  const { theme, setTheme } = useTheme();

  const currentTheme: ThemeMode =
    theme === "light" || theme === "dark" || theme === "system"
      ? theme
      : "system";

  const handleToggleTheme = () => {
    const currentThemeIndex = themeCycleOrder.indexOf(currentTheme);
    // El módulo garantiza que el índice cae dentro del array, pero con
    // `noUncheckedIndexedAccess` TypeScript no puede saberlo: de ahí el
    // respaldo, que en la práctica no llega a usarse nunca.
    const nextTheme =
      themeCycleOrder[(currentThemeIndex + 1) % themeCycleOrder.length] ??
      "system";
    setTheme(nextTheme);
  };

  const getThemeIcon = () => {
    if (currentTheme === "light") {
      return <Sun className="h-[1.2rem] w-[1.2rem]" />;
    }

    if (currentTheme === "dark") {
      return <Moon className="h-[1.2rem] w-[1.2rem]" />;
    }

    return (
      <span className="relative h-[1.2rem] w-[1.2rem]">
        <Sun className="absolute top-0 -left-0.5 h-[0.8rem] w-[0.8rem]" />
        <Moon className="absolute -right-0.5 bottom-0 h-[0.8rem] w-[0.8rem]" />
      </span>
    );
  };

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={handleToggleTheme}
      aria-label={`Cambiar tema: ${currentTheme}`}
      title={`Cambiar tema: ${currentTheme}`}
    >
      {getThemeIcon()}
      <span className="sr-only">Cambiar tema</span>
    </Button>
  );
}
